import { render, staticRenderFns } from "./echartsChina.vue?vue&type=template&id=072a9298&scoped=true&"
import script from "./echartsChina.vue?vue&type=script&lang=js&"
export * from "./echartsChina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a9298",
  null
  
)

export default component.exports